const headerData = [
  {
    prop: "id",
    label: "序号",
    columnwidth: 50,
  },
  {
    prop: "QuotaTypeName",
    label: "指标类型",
    columnwidth: 100,
  },
  {
    prop: "InvClassName",
    label: "产品线",
    columnwidth: 80,
  },
  {
    prop: "CusName",
    label: "客户名称",
    columnwidth: 264,
  },
  {
    prop: "Year",
    label: "年份",
    columnwidth: 60,
  },
  {
    prop: "JanQuota",
    label: "一月指标",
    columnwidth: 100,
  },
  {
    prop: "JanSales",
    label: "一月实际采购",
    columnwidth: 100,
  },
  {
    prop: "JanRatio",
    label: "一月完成度",
    columnwidth: 100,
  },
  {
    prop: "FebQuota",
    label: "二月指标",
    columnwidth: 100,
  },
  {
    prop: "FebSales",
    label: "二月实际采购",
    columnwidth: 100,
  },
  {
    prop: "FebRatio",
    label: "二月完成度",
    columnwidth: 100,
  },
  {
    prop: "MarQuota",
    label: "三月指标",
    columnwidth: 100,
  },
  {
    prop: "MarSales",
    label: "三月实际采购",
    columnwidth: 100,
  },
  {
    prop: "MarRatio",
    label: "三月完成度",
    columnwidth: 100,
  },
  {
    prop: "FirstQuarterRatio",
    label: "第一季度完成度",
    columnwidth: 100,
  },
  {
    prop: "AprQuota",
    label: "四月指标",
    columnwidth: 100,
  },
  {
    prop: "AprSales",
    label: "四月实际采购",
    columnwidth: 100,
  },
  {
    prop: "AprRatio",
    label: "四月完成度",
    columnwidth: 100,
  },
  {
    prop: "MayQuota",
    label: "五月指标",
    columnwidth: 100,
  },
  {
    prop: "MaySales",
    label: "五月实际采购",
    columnwidth: 100,
  },
  {
    prop: "MayRatio",
    label: "五月完成度",
    columnwidth: 100,
  },
  {
    prop: "JunQuota",
    label: "六月指标",
    columnwidth: 100,
  },
  {
    prop: "JunSales",
    label: "六月实际采购",
    columnwidth: 100,
  },
  {
    prop: "JunRatio",
    label: "六月完成度",
    columnwidth: 100,
  },
  {
    prop: "SecondQuarterQuota",
    label: "第二季度指标",
    columnwidth: 100,
  },
  {
    prop: "SecondQuarterSales",
    label: "第二季度实际采购",
    columnwidth: 100,
  },
  {
    prop: "SecondQuarterRatio",
    label: "第二季度完成度",
    columnwidth: 100,
  },
  {
    prop: "JulQuota",
    label: "七月指标",
    columnwidth: 100,
  },
  {
    prop: "JulSales",
    label: "七月实际采购",
    columnwidth: 100,
  },
  {
    prop: "JulRatio",
    label: "七月完成度",
    columnwidth: 100,
  },
  {
    prop: "AugQuota",
    label: "八月指标",
    columnwidth: 100,
  },
  {
    prop: "AugSales",
    label: "八月实际采购",
    columnwidth: 100,
  },
  {
    prop: "AugRatio",
    label: "八月完成度",
    columnwidth: 100,
  },
  {
    prop: "SepQuota",
    label: "九月指标",
    columnwidth: 100,
  },
  {
    prop: "SepSales",
    label: "九月实际采购",
    columnwidth: 100,
  },
  {
    prop: "SepRatio",
    label: "九月完成度",
    columnwidth: 100,
  },
  {
    prop: "ThirdQuarterQuota",
    label: "第三季度指标",
    columnwidth: 100,
  },
  {
    prop: "ThirdQuarterSales",
    label: "第三季度实际采购",
    columnwidth: 100,
  },
  {
    prop: "ThirdQuarterRatio",
    label: "第三季度完成度",
    columnwidth: 100,
  },
  {
    prop: "OctQuota",
    label: "十月指标",
    columnwidth: 100,
  },
  {
    prop: "OctSales",
    label: "十月实际采购",
    columnwidth: 100,
  },
  {
    prop: "OctRatio",
    label: "十月完成度",
    columnwidth: 100,
  },
  {
    prop: "NovQuota",
    label: "十一月指标",
    columnwidth: 100,
  },
  {
    prop: "NovSales",
    label: "十一月实际采购",
    columnwidth: 100,
  },
  {
    prop: "NovRatio",
    label: "十一月完成度",
    columnwidth: 100,
  },
  {
    prop: "DecQuota",
    label: "十二月指标",
    columnwidth: 100,
  },
  {
    prop: "DecSales",
    label: "十二月实际采购",
    columnwidth: 100,
  },
  {
    prop: "DecRatio",
    label: "十二月完成度",
    columnwidth: 100,
  },
  {
    prop: "ForthQuarterQuota",
    label: "第四季度指标",
    columnwidth: 100,
  },
  {
    prop: "ForthQuarterSales",
    label: "第四季度实际采购",
    columnwidth: 100,
  },
  {
    prop: "ForthQuarterRatio",
    label: "第四季度完成度",
    columnwidth: 100,
  },
  {
    prop: "YearQuota",
    label: "全年指标",
    columnwidth: 100,
  },
  {
    prop: "YearSales",
    label: "全年实际采购",
    columnwidth: 100,
  },
  {
    prop: "YearRatio",
    label: "全年完成度",
    columnwidth: 100,
  }
]

export default headerData
